import React from "react";
import Link from "@qlik/qlik/src/components/Link";
import { createParameterizedUrl, renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import { useLocation } from "@reach/router";

const CardIcon = ({ data }) => {
    const { title, icon, description, ctaLabel, browsingContext } = data ?? {};
    const iconUrl = icon?.[0]?.secure_url?.replace("/f_auto", "").replace("/q_auto", "");
    const location = useLocation();

    let pageUrl = createParameterizedUrl(data);
    const linkProps = {
        to: pageUrl,
        newWindow: browsingContext === "New Tab",
        className: "z-1 group/link relative block",
    };

    return (
        <Link {...linkProps}>
            <span className="-z-1 absolute -inset-3 rounded bg-white shadow-xlSmall opacity-0 transition-opacity transition-300 xl:group-hover/link:opacity-100" />

            <div className="card-icon">
                {iconUrl && (
                    <picture>
                        <source media="(max-width:768px)" />
                        <img
                            loading="lazy"
                            src={iconUrl}
                            alt={title}
                            className="w-10 h-10 object-contain mb-5 object-left"
                        />
                    </picture>
                )}

                {title && (
                    <h3
                        className="text-md text-gray font-bold tracking-normal leading-none"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                    />
                )}
                {description && (
                    <p className="text-gray text-sm font-normal tracking-normal leading-tight mt-2.5">{description}</p>
                )}
                {ctaLabel && (
                    <span className="green-link link-text mt-5 xl:group-hover/link:text-dark-green xl:group-hover/link:after:arrow-green-dark xl:group-hover/link:after:translate-x-0.75">
                        {ctaLabel}
                    </span>
                )}
            </div>
        </Link>
    );
};

export default CardIcon;
